import {Splide, SplideSlide} from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Link, useNavigate} from "react-router-dom";
import Card from "../../../../reusableComponents/Card";
import {setSelectedChallenge} from "../../../../store/reducers/accountSlice";
import "./style.scss";
import {currnecyFormatter, formatUSD} from "../../../../utils/helpers/string";
import TierHeader from "../TierHeader";

// TierDetails component
const TierDetails = ({tier, tiersName, tiers, planItems}) => {
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  console.log("plans-plan-container", planItems?.id, tier);

  return (
    <>
      <div className="tier_header_values">
        <div className="tier-num">
          {(planItems?.type === "1_step" || planItems?.type === "2_step") && selectedBrand?.brand === "equity_edge" ? (
            <div className="tier_val">
              <p className="heading">Leverage</p>
              <p className={`leverageBox ${selectedBrand?.brand === "equity_edge" ? "grid" : ""}`}>
                {planItems?.id === 21 || planItems?.id === 22 ? (
                  <span>Up to 1 : 30 </span>
                ) : planItems?.id === 23 ? (
                  <span>Up to 1 : 50 </span>
                ) : planItems?.id === 24 ? (
                  <span>Up to 1 : 100 </span>
                ) : (
                  <span>Up to 1 : 40</span>
                )}
              </p>
            </div>
          ) : selectedBrand?.brand === "equity_edge" && planItems?.type !== "pro_edge" ? (
            <div className="tier_val">
              <p className="heading">Leverage</p>
              <p>Up to 1 : 100</p>
            </div>
          ) : (
            <></>
          )}
          {(planItems?.type === "1_step" || planItems?.type === "2_step" || planItems?.type === "pro_edge") && selectedBrand?.brand === "crypto_edge" && (
            <div className="tier_val">
              <p className="heading">Leverage (BTC/ETH)</p>
              <p className="leverageBox">
                <span>1 : 3 </span>
              </p>
            </div>
          )}

          {planItems?.type === "pro_edge" && (
            <div className="tier_val">
              <p className="heading">Leverage</p>
              <p className={`leverageBox ${selectedBrand?.brand === "equity_edge" ? "grid" : ""}`}>
                <span>Up to 1 : 30</span>
                {/* <span>1 : 10 (Indices)</span>
                <span>1 : 10 (Metals)</span>
                <span>1 : 2 (Crypto)</span> */}
              </p>
            </div>
          )}

          {/* {planItems?.name?.toLowerCase()?.includes("swift") ? (
            <div className="tier_val">
              <p className="heading">Leverage</p>
              <p>1 : 1</p>
            </div>
          ) : (
            <div className="tier_val">
              <p className="heading">Leverage {selectedBrand?.brand === "crypto_edge" ? "(ALT Coin)" : "(Crypto)"}</p>
              <p>1 : 2 (Crypto)</p>
            </div>
          )} */}

          {selectedBrand?.brand === "crypto_edge" ? (
            <div className="tier_val">
              <p className="heading">Leverage {selectedBrand?.brand === "crypto_edge" ? "(ALT Coin)" : "(Crypto)"}</p>
              <p>1 : 2</p>
            </div>
          ) : (
            <></>
          )}

          <div className="tier_val">
            <p className="heading">Min Trading Days</p>
            <p>{tier?.min_trading_days === 0 ? "N/A" : tier?.min_trading_days + " days"}</p>
          </div>

          <div className="tier_val">
            <p className="heading">Max Daily Loss</p>
            <p>{parseFloat(tier?.max_daily_loss).toFixed(0) ?? "-"}%</p>
          </div>
          <div className="tier_val">
            {/* <p className="heading">{tier.plan === 2 || tier.plan === 13 ? "Max Loss (Trailing)" : "Max Loss"}</p> */}
            <p className="heading">
              {planItems?.type === "1_step" ? "Max Loss Trailing" : planItems?.type === "2_step" ? "Max Loss" : planItems?.type === "pro_edge" ? "Max Loss Trailing" : "Max Loss"}
            </p>
            <p>{Number(tier?.max_loss)?.toFixed(0) ?? "-"}%</p>
          </div>
          {planItems?.type === "pro_edge" && (
            <div className="tier_val">
              <p className="heading">Consistency Score</p>
              <p>{tier?.consistency_score ? `${tier.consistency_score}%` : "15%"}</p>
            </div>
          )}

          {/* {tier?.plan === 2 || tier?.plan === 14 || tier?.plan === 13 ? (
            <div className="tier_val">
              <p className="heading">Profit Target</p>
              <p>{`${tier?.profit_target_1 === 0 ? "N/A" : tier?.profit_target_1 + "%"}` ?? "-"}</p>
            </div>
          ) : (
            <div className="tier_val">
              <p className="heading">Profit Target 1</p>
              <p>{tier?.profit_target_1 ?? "-"} %</p>
            </div>
          )} */}

          <div className="tier_val">
            {tier?.plan === 2 ||
            tier?.plan === 14 ||
            tier?.plan === 13 ||
            tier?.plan === 7 ||
            tier?.plan === 16 ||
            tier?.plan === 18 ||
            planItems?.id === 19 ||
            planItems?.id === 21 ||
            planItems?.id === 22 ||
            tier?.plan === 42 ||
            planItems?.id === 23 ? (
              <p className="heading">Profit Target</p>
            ) : (
              <p className="heading">Profit Target 1</p>
            )}
            <p>{`${tier?.profit_target_1 === 0 ? "N/A" : tier?.profit_target_1 + "%"}` ?? "-"}</p>
          </div>

          {tier?.profit_target_2 ? (
            <div className="tier_val">
              <p className="heading">Profit Target 2</p>
              <p>{tier?.profit_target_2 ?? "-"} %</p>
            </div>
          ) : (
            <></>
          )}

          {tier?.plan === 15 && (
            <div className="tier_val">
              <p className="heading">Profit Target 2</p>
              <p>{tier?.profit_target_2 ?? "-"} %</p>
            </div>
          )}
          <div className="tier_val">
            <p className="heading">Profit Share</p>
            <p>{parseFloat(tier?.profit_share).toFixed(0) ?? "-"}%</p>
          </div>

          {planItems?.type === "pro_edge" && (
            <>
              <div className="tier_val">
                <p className="heading">Max Risk</p>
                <p>{tier?.max_risk ? `${tier.max_risk}%` : "1%"}</p>
              </div>
              <div className="tier_val">
                <p className="heading">Safety Cushion</p>
                <p>{tier?.safety_cushion ? `${tier.safety_cushion}%` : "3%"}</p>
              </div>
              <div className="tier_val">
                <p className="heading">Inactivity Rule</p>
                <p>{tier?.inactivity_days ? `${tier.inactivity_days} Days` : "30 Days"}</p>
              </div>
            </>
          )}

          <div className="tier_val">
            <p className="heading">Starting Balance</p>
            <p>{formatUSD(tier?.starting_balance) ?? "-"}</p>
          </div>
          {/* <div className="tier_val">
            <p className="heading">EA</p>
            <p>{tier?.ea ? "Yes" : "No"}</p>
          </div> */}

          <div className="tier_val">
            <p className="heading">Tradable Assets</p>
            {selectedBrand?.brand === "equity_edge" ? <p className="heading">{"FX / Indices / Metals / Oil / Crypto"}</p> : <p className="heading">{"Crypto"}</p>}
          </div>

          <div className="tier_val">
            <p className="heading">Trade Through News</p>
            {/* <p>{tier?.trade_through_news ? "Yes" : "No"}</p> */}
            <p>{"Yes"}</p>
          </div>
          {selectedBrand?.brand === "equity_edge" && (
            <div className="tier_val">
              <p className="heading">Hold Over The Weekend</p>
              <p>{tier?.hold_over_the_weekend ? "Yes" : "No"}</p>
            </div>
          )}
          {/* <div className="tier_val">
            <p className="heading">Hedging & Stacking</p>
            <p>Yes</p>
          </div> */}
        </div>
      </div>
    </>
  );
};

// TierCard component
const TierCard = ({userCountry, tier, activeTier, tiersName, setActiveTier, broker, tiers, planItems}) => {
  const dispatch = useDispatch();
  const getOriginalPrice = (price) => {
    const priceMap = {
      "15.00": "$18",
      "20.00": "$34",
      "30.00": "$67",
      "220.00": "$277",
      "120.00": "$167",
      "500.00": "$577",
    };

    return priceMap[price] || ""; // Return the mapped price or an empty string if no match
  };
  const navigate = useNavigate();

  console.log("tiersNamtiersNamee", activeTier, tiers, planItems);

  return (
    <div className="tier_wrapper">
      <div className="tier_upper">
        <div className="tier-type">
          {tiers?.id === 42 ? (
            <h3>
              {`$${(tier?.starting_balance / 1000) % 1 === 0 ? (tier?.starting_balance / 1000).toFixed(0) : (tier?.starting_balance / 1000).toFixed(1)}k`}{" "}
              <span style={{fontSize: "15px"}}>Competition</span>
            </h3>
          ) : (
            <h3>{`$${(tier?.starting_balance / 1000) % 1 === 0 ? (tier?.starting_balance / 1000).toFixed(0) : (tier?.starting_balance / 1000).toFixed(1)}k`}</h3>
          )}
        </div>
        <div className="tier-price">
          {/* <h3>${(tier?.starting_balance / 1000).toFixed(1)}k</h3> */}
          {/* <p>Challenge</p> */}
        </div>
      </div>
      <Card
        className={`tier-container ${tier?.id === activeTier ? "tier-highlight" : ""}`}
        onClick={() => setActiveTier(tier.id)}
      >
        <TierDetails
          tier={tier}
          tiersName={tiersName}
          tiers={tiers}
          planItems={planItems}
        />
        <div className="buyNow_Section">
          <div
            onClick={() =>
              (planItems?.id === 23 || planItems?.id === 24) && (userCountry === "Ethiopia" || userCountry === "ET") ? null : navigate(`/funding-evaluation/payments/${tier?.id}`, {state: broker})
            }
          >
            {/* <Link to={`/funding-evaluation/payments/${tier?.id}`}> */}
            <button
              className={`$try_btn ${(planItems?.id === 23 || planItems?.id === 24) && (userCountry === "Ethiopia" || userCountry === "ET") ? "not-allowed-cursor" : ""}`}
              onClick={() => ((planItems?.id === 23 || planItems?.id === 24) && (userCountry === "Ethiopia" || userCountry === "ET") ? null : dispatch(setSelectedChallenge(tier?.id)))}
            >
              {Number(tier?.price) === 0 ? (
                "Try Now"
              ) : (
                <>
                  Buy Now-{" "}
                  {/* {broker !== "tradelocker" && (
                    <>
                      <s style={{fontSize: "15px"}}>{getOriginalPrice(tier.price)}</s>
                    </>
                  )} */}
                  ${broker === "tradelocker" ? Number(tier.tradelocker_price)?.toFixed(0) : Number(tier?.price)?.toFixed(0)}
                </>
              )}
            </button>
          </div>
        </div>
      </Card>
    </div>
  );
};

// TierSlider component
const TierSlider = ({userCountry, tiersNew, tiersName, activeTier, setActiveTier, broker, planItems}) => {
  return (
    <Splide
      aria-label="My Favorite Images"
      options={{
        // autoplay: true,
        perPage: 3,
        perMove: 1,
        width: "100%",
        drag: "free",
        gap: "0px",
        pauseOnHover: false,
        breakpoints: {
          1550: {perPage: 3},
          1440: {perPage: 3},
          1170: {perPage: 2},
          970: {perPage: 2},
          800: {perPage: 1},
        },
      }}
    >
      {tiersNew?.map((tier) => {
        if (broker === "tradelocker" && (tier?.name.startsWith("2.5K") || tier?.name.startsWith("5K"))) {
          console.log(tier?.name, "kjshdfujsaf");
          return null;
        }
        return (
          <SplideSlide key={tier?.id}>
            <TierCard
              planItems={planItems}
              tier={tier}
              tiersName={tiersName}
              activeTier={activeTier}
              setActiveTier={setActiveTier}
              broker={broker}
              userCountry={userCountry}
            />
          </SplideSlide>
        );
      })}
    </Splide>
  );
};

// Main Tier component
function Tier({tiers, activeTier, setActiveTier, broker, userCountry}) {
  const sortedNumbers = [...(tiers?.challenges ?? [])].sort((a, b) => a.starting_balance - b.starting_balance);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [tiers]);
  console.log(tiers, "activeTieractiveTier");

  return (
    <>
      {sortedNumbers.length > 3 ? (
        <TierSlider
          tiersName={tiers.name}
          planItems={tiers}
          tiersNew={sortedNumbers}
          activeTier={activeTier}
          setActiveTier={setActiveTier}
          broker={broker}
          userCountry={userCountry}
        />
      ) : (
        sortedNumbers?.map((tier) => (
          <TierCard
            key={tier?.id}
            tier={tier}
            activeTier={activeTier}
            setActiveTier={setActiveTier}
            broker={broker}
            tiers={tiers}
            userCountry={userCountry}
          />
        ))
      )}
    </>
  );
}

export default Tier;
